'use client'

// src/components/utils/default.ts
import { ApiConfig } from "@wbk/api";
import { parseDateString } from "@wbk/utils";
var getDefaultUser = (user) => {
  var _a, _b, _c, _d, _e;
  const firstname = user == null ? void 0 : user.first_name;
  const lastname = user == null ? void 0 : user.last_name;
  return {
    email: ((_c = user == null ? void 0 : user.email) == null ? void 0 : _c.includes(`@${(_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource}.guest`)) ? "" : (user == null ? void 0 : user.email) || "",
    first_name: firstname === ((_e = (_d = ApiConfig.config) == null ? void 0 : _d.wbk) == null ? void 0 : _e.appSource) ? "" : firstname,
    last_name: (lastname == null ? void 0 : lastname.toLowerCase()) === "guest" ? "" : lastname,
    gender: (user == null ? void 0 : user.gender) || "",
    dob: (user == null ? void 0 : user.dob) ? parseDateString(user == null ? void 0 : user.dob) : "",
    nationality: (user == null ? void 0 : user.nationality) || "",
    country: (user == null ? void 0 : user.country) || "",
    city: (user == null ? void 0 : user.city) || "",
    passport_data: user == null ? void 0 : user.passport_data
  };
};

export {
  getDefaultUser
};
//# sourceMappingURL=chunk-BPVXCQOF.mjs.map